export class DomainUtils {

  static getNomePeloSubdomain(): string {

    const dominios = [
      {subdomain: 'apresentacao', nome: 'Apresentação'},
      {subdomain: 'pwa', nome: 'PWA'},
      {subdomain: 'barbeariamendonca', nome: 'Barbearia Mendonça'},
      {subdomain: 'jeanmoraesbarber', nome: 'Jean Moraes Barber'},
      {subdomain: 'barbeariakaiak', nome: 'Barbearia Kaiak'},
      {subdomain: 'studiolecaotatto', nome: 'Lecão Tatto Company'},
      {subdomain: 'kaerlavacar', nome: 'Kaer Lava Car	'}
    ]

    const url = window.location.href
    const subdomain = url.split('/')[2].split('.')[0]
    const dominio = dominios.find(d => d.subdomain === subdomain)
    if(dominio) {
      return dominio.nome
    }

    return 'Agenda Simplificada' 
  }
}
